export enum ApiUriEnum {
  SIGNIN = 'account/signin',
  SIGNUP = 'account/signup',
  VERIFY_OTP = 'account/verify-otp',
  ACTIVATE_2FA = 'account/activate-2fa',
  ACCOUNT_CREATE = 'account/create',
  ACCOUNT_UPDATE_EMPLOYEE = 'account/employee/update',
  ME = 'account/me',
  REFRESH_TOKEN = 'account/refresh',
  HELLO_WORLD = 'hello-world',
  CREDENTIAL_DETAIL = 'account/detail/',
  IMPORT_FILE = '/import',

  //Employee
  EMPLOYEE = 'employee',
  ACCOUNT_EMPLOYEE = 'account/employee',
  EMPLOYEE_LIST = 'employee/list',
  EMPLOYEE_DETAIL = 'employee/detail/',
  EMPLOYEE_CREATE = 'employee/create',
  EMPLOYEE_UPDATE = 'employee/update',
  EMPLOYEE_DELETE = 'employee/delete/',
  EMPLOYEE_SOFTDELETE = 'employee/softdelete/',
  EMPLOYEE_ROLLBACK = 'employee/rollbackdelete/',
  EMPLOYEE_ERASE = 'employee/erase/',
  EMPLOYEE_NO_PAGINATION_LIST = 'employee/listNoPagination',
  EMPLOYEE_SEARCH = 'employee/filteredList',
  EMPLOYEE_ALL_PRESTATION_SUMMARY = 'planningCell/employees/summary',
  EMPLOYEE_PRESTATION_SUMMARY = 'planningCell/employees',
  EMPLOYEE_BATCH_UPDATE = 'employee/batchUpdate',
  EMPLOYEE_PROFILE = 'employee/profile',
  EMPLOYEE_PROFILE_PICTURE = 'employee/picture',
  EMPLOYEE_PICTURE_GET = 'employee/picture/',
  IMAGES_GET = 'images/',

  //Parameter
  PARAMETER_LIST = 'parameter/list',
  PARAMETER_DETAIL = 'parameter/detail/',
  PARAMETER_CREATE = 'parameter/create',
  PARAMETER_UPDATE = 'parameter/update',
  PARAMETER_DELETE = 'parameter/delete/',
  PARAMETER_DELETED_LIST = 'parameter/deleted',
  PARAMETER_SOFTDELETE = 'parameter/softdelete/',
  PARAMETER_ROLLBACK = 'parameter/rollbackdelete/',
  PARAMETER_ERASE = 'parameter/erase/',
  PARAMETER_LIST_BY_EMPLOYEE_ID = 'parameter/listByEmployeeId',
  PARAMETER_LIST_NO_PAGINATION = 'parameter/listNoPagination',
  PARAMETER_GET_EMPLOYEE = 'parameter/getEmployee/',

  //PrestationType
  PRESTATIONTYPE_LIST = 'prestationType/list',
  PRESTATIONTYPE_DETAIL = 'prestationType/detail/',
  PRESTATIONTYPE_CREATE = 'prestationType/create',
  PRESTATIONTYPE_UPDATE = 'prestationType/update',
  PRESTATIONTYPE_DELETE = 'prestationType/delete/',
  PRESTATIONTYPE_DELETED_LIST = 'prestationType/deleted',
  PRESTATIONTYPE_SOFTDELETE = 'prestationType/softdelete/',
  PRESTATIONTYPE_ROLLBACK = 'prestationType/rollbackdelete/',
  PRESTATIONTYPE_ERASE = 'prestationType/erase/',
  PRESTATIONTYPE_NO_PAGINATION_LIST = 'prestationType/listNoPagination',
  PRESTATIONTYPE_SEARCH = 'prestationType/filteredList',

  //Prestation group
  PRESTATION_GROUP_LIST = 'prestationGroup/listNoPagination',
  PRESTATION_GROUP_DETAIL = 'prestationGroup/detail/',
  PRESTATION_GROUP_CREATE = 'prestationGroup/create',
  PRESTATION_GROUP_UPDATE = 'prestationGroup/update',
  PRESTATION_GROUP_DELETE = 'prestationGroup/',

  //Prestation
  PRESTATION_LIST = 'prestation/list',
  PRESTATION_LIST_GENERATOR_TEMPLATE = 'prestation/list/',
  PRESTATION_DETAIL = 'prestation/detail/',
  PRESTATION_CREATE = 'prestation/create',
  PRESTATION_UPDATE = 'prestation/update',
  PRESTATION_DELETE = 'prestation/delete/',
  PRESTATION_DELETED_LIST = 'prestation/deleted',
  PRESTATION_SOFTDELETE = 'prestation/softdelete/',
  PRESTATION_ROLLBACK = 'prestation/rollbackdelete/',
  PRESTATION_ERASE = 'prestation/erase/',

  //Address
  ADDRESS_LIST = 'address/list',
  ADDRESS_DELETED_LIST = 'address/deleted',
  ADDRESS_DETAIL = 'address/detail/',
  ADDRESS_CREATE = 'address/create',
  ADDRESS_UPDATE = 'address/update',
  ADDRESS_SOFTDELETE = 'address/softdelete/',
  ADDRESS_ROLLBACK = 'address/rollbackdelete/',
  ADDRESS_ERASE = 'address/erase/',

  //Generator template
  GENERATOR_TEMPLATE_LIST = 'generatorTemplate/list',
  GENERATOR_TEMPLATE_DETAIL = 'generatorTemplate/detail/',
  GENERATOR_TEMPLATE_CREATE = 'generatorTemplate/create',
  GENERATOR_TEMPLATE_UPDATE = 'generatorTemplate/update',
  GENERATOR_TEMPLATE_DELETE = 'generatorTemplate/delete/',
  GENERATOR_TEMPLATE_DELETED_LIST = 'generatorTemplate/deleted',
  GENERATOR_TEMPLATE_SOFTDELETE = 'generatorTemplate/softdelete/',
  GENERATOR_TEMPLATE_ROLLBACK = 'generatorTemplate/rollbackdelete/',
  GENERATOR_TEMPLATE_ERASE = 'generatorTemplate/erase/',
  GENERATOR_TEMPLATE_NO_PAGINATION_LIST = 'generatorTemplate/listNoPagination',
  GENERATOR_TEMPLATE_SEARCH = 'generatorTemplate/filteredList',

  //Generator
  GENERATOR_CREATE = 'generator/create',

  //Role
  ROLE_LIST = 'role/list',
  ROLE_DETAIL = 'role/detail/',
  ROLE_CREATE = 'role/create',
  ROLE_UPDATE = 'role/update',
  ROLE_DELETE = 'role/delete/',
  ROLE_DELETED_LIST = 'role/deleted',
  ROLE_SOFTDELETE = 'role/softdelete/',
  ROLE_ROLLBACK = 'role/rollbackdelete/',
  ROLE_ERASE = 'role/erase/',
  ROLE_NO_PAGINATION_LIST = 'role/listNoPagination',
  ROLE_SEARCH = 'role/filteredList',

  //Control
  CONTROL_LIST = 'control/list',
  CONTROL_DETAIL = 'control/detail/',
  CONTROL_CREATE = 'control/create',
  CONTROL_UPDATE = 'control/update',
  CONTROL_DELETE = 'control/delete/',
  CONTROL_DELETED_LIST = 'control/deleted',
  CONTROL_SOFTDELETE = 'control/softdelete/',
  CONTROL_ROLLBACK = 'control/rollbackdelete/',
  CONTROL_ERASE = 'control/erase/',
  CONTROL_NO_PAGINATION_LIST = 'control/listNoPagination',
  CONTROL_SEARCH = 'control/filteredList',
  CONTROL_ON_PLANNING = 'planningCell/controlAllPlanningCellPeriod',

  //Planning
  PLANNING_LIST = 'planning/list',
  PLANNING_IMPORT = 'planning/',
  PLANNING_DETAIL = 'planning/detail/',
  PLANNING_CREATE = 'planning/create',
  PLANNING_UPDATE = 'planning/update',
  PLANNING_DELETE = 'planning/delete/',
  PLANNING_DELETED_LIST = 'planning/deleted',
  PLANNING_SOFTDELETE = 'planning/softdelete/',
  PLANNING_ROLLBACK = 'planning/rollbackdelete/',
  PLANNING_ERASE = 'planning/erase/',
  PLANNING_EXPORT_EXCEL = 'planning/exportexcel',
  PLANNING_EXPORT_PDF = 'planning/exportpdf',

  //Planning Cell
  PLANNING_CELL = 'planningCell',
  PLANNING_CELL_LIST = 'planningCell/list',
  PLANNING_CELL_DETAIL = 'planningCell/detail/',
  PLANNING_CELL_CREATE = 'planningCell/create',
  PLANNING_CELL_CREATE_WITHOUT_CONTROLS = 'planningCell/createWithoutControl',
  PLANNING_CELL_UPDATE = 'planningCell/update',
  PLANNING_CELL_DELETE = 'planningCell/delete/',
  PLANNING_CELL_DELETED_LIST = 'planningCell/deleted',
  PLANNING_CELL_SOFTDELETE = 'planningCell/softdelete/',
  PLANNING_CELL_ROLLBACK = 'planningCell/rollbackdelete/',
  PLANNING_CELL_ERASE = 'planningCell/delete/',
  PLANNING_CELL_COPY = 'planningCell/copy/',
  PLANNING_CELL_CUT = 'planningCell/cut/',
  PLANNING_CELL_SWITCH = 'planningCell/switch/',
  PLANNING_CELL_BY_PLANNING_AND_MONTH = 'planningCell/planningAndMonth/',
  PLANNING_CELLS_BETWEEN_DATES = 'planningCell/planningBetweenDates/',
  PLANNING_COPY_PLANNING_CELLS_BETTWEN_SELECTED_TO_MAIN_PLANNING = 'planningCell/CopyPlanningCellsBettwenSelectedDateToMainPlanning',
  PLANNING_CELL_ADD_TASK = 'planningCell/tasks/add',
  PLANNING_CELL_REMOVE_TASK = 'planningCell/tasks/remove',
  PLANNING_CELL_BATCH_DELETE = 'planningCell/delete',
  PLANNING_CELL_BATCH_LOCK = 'planningCell/batchLock',
  PLANNING_CELL_HOURS = 'planningCell/hours',
  PLANNING_CELL_EMPLOYEE_AVAILABILITY = 'planningCell/getListOfEmployeeAvailable',
  PLANNING_CELL_TRANSFER = 'planningCell/transferPrestations',
  PLANNING_CELL_UNDO = 'planningCell/undo',
  PLANNING_CELL_REDO = 'planningCell/redo',
  PLANNING_CELL_UNDO_REDO_COUNT = 'planningCell/countUndoRedo',

  // Event
  EVENT = 'event/',
  EVENT_LIST = 'event/listNoPagination',
  EVENT_CREATE = 'event/create',
  PLANNING_SCHEDULED_EVENTS = 'event/planning/',
  EVENT_DETAIL = 'event/detail/',
  EVENT_SOFT_DELETE = 'event/softdelete/',
  EVENT_ROLLBACK_DELETE = 'event/rollback/',
  EVENT_ERASE = 'event/detail/',
  EVENT_ADD_TO_PLANNING = 'event/addToPlanning',
  EVENT_REMOVE_SCHEDULED = 'event/scheduled/',
  EVENT_SCHEDULED_COMMENTS = 'event/scheduled/comments',

  // Exchange request
  EXCHANGE_REQUEST_LIST = 'planning-cell-validation/list',
  EXCHANGE_REQUEST_CREATE = 'planning-cell-validation/create',
  EXCHANGE_REQUEST_HANDLE_EMPLOYEE = 'planning-cell-validation/validate-or-reject-employee',
  EXCHANGE_REQUEST_HANDLE_ADMIN = 'planning-cell-validation/validate-or-reject-admin',


  //Team
  TEAM = 'team/',
  TEAM_LIST = 'team/list',
  TEAM_LIST_HERITAGE = 'team/listHeritage',
  TEAM_DETAIL = 'team/detail/',
  TEAM_CREATE = 'team/create',
  TEAM_UPDATE = 'team/update',
  TEAM_DELETE = 'team/delete/',
  TEAM_DELETED_LIST = 'team/deleted',
  TEAM_SOFTDELETE = 'team/softdelete/',
  TEAM_ROLLBACK = 'team/rollbackdelete/',
  TEAM_ERASE = 'team/erase/',
  TEAM_POTENTIAL_PARENTS = 'team/listPotentialParents/',
  TEAM_NO_PAGINATION_LIST = 'team/listNoPagination',
  TEAM_LIST_ALL = 'team/listAll',
  TEAM_SEARCH = 'team/filteredList',

  //Remember
  REMEMBER_LIST = 'remember/list',
  REMEMBER_TODAY = 'remember/today',
  REMEMBER_DETAIL = 'remember/detail/',
  REMEMBER_CREATE = 'remember/create',
  REMEMBER_UPDATE = 'remember/update',
  REMEMBER_DELETE = 'remember/delete/',
  REMEMBER_DELETED_LIST = 'remember/deleted',
  REMEMBER_SOFTDELETE = 'remember/softdelete/',
  REMEMBER_ROLLBACK = 'remember/rollbackdelete/',
  REMEMBER_ERASE = 'remember/erase/',
  REMEMBER_NO_PAGINATION_LIST = 'remember/listNoPagination',
  REMEMBER_SEARCH = 'remember/filteredList',

  // Remember type
  REMEMBER_TYPE_LIST = 'rememberType/list',
  REMEMBER_TYPE_DETAIL = 'rememberType/detail/',
  REMEMBER_TYPE_CREATE = 'rememberType/create',
  REMEMBER_TYPE_UPDATE = 'rememberType/update',
  REMEMBER_TYPE = 'rememberType/',

  //History
  HISTORY_LIST = 'history/list',
  HISTORY_DETAIL = 'history/detail/',
  HISTORY_CREATE = 'history/create',
  HISTORY_UPDATE = 'history/update',
  HISTORY_DELETE = 'history/delete/',
  HISTORY_DELETED_LIST = 'history/deleted',
  HISTORY_SOFTDELETE = 'history/softdelete/',
  HISTORY_ROLLBACK = 'history/rollbackdelete/',
  HISTORY_ERASE = 'history/erase/',

  //Permission
  PERMISSION_LIST = 'permission/list',
  PERMISSION_DETAIL = 'permission/detail/',
  PERMISSION_CREATE = 'permission/create',
  PERMISSION_UPDATE = 'permission/update',
  PERMISSION_DELETE = 'permission/delete/',
  PERMISSION_DELETED_LIST = 'permission/deleted',
  PERMISSION_SOFTDELETE = 'permission/softdelete/',
  PERMISSION_ROLLBACK = 'permission/rollbackdelete/',
  PERMISSION_ERASE = 'permission/erase/',

  //VisualPrestationType
  VISUALISATIONPRESTATIONTYPE_LIST = 'visualPrestationType/list',
  VISUALISATIONPRESTATIONTYPE_DETAIL = 'visualPrestationType/detail/',
  VISUALISATIONPRESTATIONTYPE_CREATE = 'visualPrestationType/create',
  VISUALISATIONPRESTATIONTYPE_UPDATE = 'visualPrestationType/update',
  VISUALISATIONPRESTATIONTYPE_DELETE = 'visualPrestationType/delete/',
  VISUALISATIONPRESTATIONTYPE_DELETED_LIST = 'visualPrestationType/deleted',
  VISUALISATIONPRESTATIONTYPE_SOFTDELETE = 'visualPrestationType/softdelete/',
  VISUALISATIONPRESTATIONTYPE_ROLLBACK = 'visualPrestationType/rollbackdelete/',
  VISUALISATIONPRESTATIONTYPE_ERASE = 'visualPrestationType/erase/',

  //Leave
  LEAVE_LIST = 'leave/list',
  LEAVE_DETAIL = 'leave/detail/',
  LEAVE_CREATE = 'leave/create',
  LEAVE_UPDATE = 'leave/update',
  LEAVE_DELETE = 'leave/delete/',
  LEAVE_DELETED_LIST = 'leave/deleted',
  LEAVE_SOFTDELETE = 'leave/softdelete/',
  LEAVE_ROLLBACK = 'leave/rollbackdelete/',
  LEAVE_ERASE = 'leave/erase/',
  LEAVE_LEAVES_LIST = 'leave/leaveslist',
  LEAVE_HOLIDAYS_LIST = 'leave/holidayslist',
  LEAVE_ALL_ACTIVE_LIST = 'leave/nopagelist',

  //Task
  TASK_LIST = 'task/list',
  TASK_BY_PRESTATION = 'task/listByPrestation/',
  TASK_DETAIL = 'task/detail/',
  TASK_CREATE = 'task/create',
  TASK_UPDATE = 'task/update',
  TASK_DELETE = 'task/delete/',
  TASK_DELETED_LIST = 'task/deleted',
  TASK_SOFTDELETE = 'task/softdelete/',
  TASK_ROLLBACK = 'task/rollbackdelete/',
  TASK_ERASE = 'task/erase/',
  TASK_NO_PAGINATION_LIST = 'task/listNoPagination',
  TASK_SEARCH = 'task/filteredList',

  //Comment
  COMMENT_LIST = 'comment/list',
  COMMENT_DETAIL = 'comment/detail/',
  COMMENT_CREATE = 'comment/create',
  COMMENT_UPDATE = 'comment/update',
  COMMENT_DELETE = 'comment/delete/',
  COMMENT_DELETED_LIST = 'comment/deleted',
  COMMENT_SOFTDELETE = 'comment/softdelete/',
  COMMENT_ROLLBACK = 'comment/rollbackdelete/',
  COMMENT_ERASE = 'comment/erase/',
  COMMENT_NO_PAGINATION_LIST = 'comment/listNoPagination',
  COMMENT_SEARCH = 'comment/filteredList',
  COMMENT_FILTER = 'comment/filter',
  COMMENT_BY_EMPLOYEE_AND_PLANNINGCELL = 'comment/employeeAndPlanningCell/',

  // Snapshot
  SNAPSHOT = 'snapshot/',
  SNAPSHOT_LIST = 'snapshot/list/',
  SNAPSHOT_CREATE = 'snapshot/create',
  SNAPSHOT_RESTORE = 'snapshot/restore/',

  // Section prestation
  SECTION_PRESTATION_LIST = 'sectionPrestation/list',
  SECTION_PRESTATION_CREATE = 'sectionPrestation/create',
  SECTION_PRESTATION_DUPLICATE = 'sectionPrestation/duplicate',
  SECTION_PRESTATION_DELETE = 'sectionPrestation/delete',

// Planning restriction
  PLANNING_RESTRICTION = 'planningRestrictions',
  PLANNING_RESTRICTION_LIST = 'planningRestrictions/list',
  PLANNING_RESTRICTION_DETAILS = 'planningRestrictions/details',
  PLANNING_RESTRICTION_CREATE = 'planningRestrictions/create',
  PLANNING_RESTRICTION_UPDATE = 'planningRestrictions/update',

// Rank
  RANK = 'rank',
  RANK_LIST = 'rank/listNoPagination',
  RANK_FILTER = 'rank/filter',
  RANK_DETAILS = 'rank/details',
  RANK_CREATE = 'rank/create',
  RANK_UPDATE = 'rank/update',
  RANK_DELETE = 'rank/delete',

// Specialization
  SPECIALIZATION_LIST = 'specialization/list',
  SPECIALIZATION_DETAILS = 'specialization/details/',
  SPECIALIZATION_CREATE = 'specialization/create',
  SPECIALIZATION_UPDATE = 'specialization/update',
  SPECIALIZATION_DELETE = 'specialization',

// Particularity
  PARTICULARITY_LIST = 'particularities/list',
  PARTICULARITY_DETAILS = 'particularities/details/',
  PARTICULARITY_CREATE = 'particularities/create',
  PARTICULARITY_UPDATE = 'particularities/update',
  PARTICULARITY_DELETE = 'particularities',

// Desideratas
  PERSONAL_CONTROL_LIST = 'desideratas/listNoPagination',
  PERSONAL_CONTROL_DETAILS = 'desideratas/detail',
  PERSONAL_CONTROL_EMPLOYEE = 'desideratas/employee',
  PERSONAL_CONTROL_CREATE = 'desideratas/create',
  PERSONAL_CONTROL_UPDATE = 'desideratas/update',
  DESIDERATA_DELETE = 'desideratas/delete',

// Section statistics
  SECTION_STATISTICS_LIST = 'sectionStatistics/list',
  SECTION_STATISTICS_CREATE = 'sectionStatistics/create',
  SECTION_STATISTICS_DELETE = 'sectionStatistics/',

// Notifications
  NOTIFICATIONS_LIST = 'notifications',
  NOTIFICATIONS_COUNT = 'notifications/count',
  NOTIFICATIONS_UPDATE_STATUS = 'notifications/status',
  NOTIFICATIONS_DELETE = 'notifications/delete',

// Absence types
  ABSENCE_TYPE_LIST = 'absence-type/listNoPagination',
  ABSENCE_TYPE_DETAIL = 'absence-type/detail/',
  ABSENCE_TYPE_CREATE = 'absence-type/create/',
  ABSENCE_TYPE_UPDATE = 'absence-type/update/',
  ABSENCE_TYPE_DELETE = 'absence-type/erase/',

// Absences
  ABSENCE_LIST_NO_PAGINATION = 'absence/listNoPagination',
  ABSENCE_CREATE = 'absence/create',
  ABSENCE_LIST = 'absence/list',
  ABSENCE_DECISION = 'absence/validate-reject',
  ABSENCE_REQUEST = 'absence/request',
  ABSENCE_ERASE = 'absence/erase/',
  ABSENCE_SOFTDELETE = 'absence/softdelete/',
  ABSENCE_UPDATE = 'absence/update',

// Employee wish
  EMPLOYEE_WISH = 'employee-wish',
  EMPLOYEE_WISH_MULTIPLE = 'employee-wish/multiple',

// IA
  IA = 'ia',
  IA_CHAT = 'ia/chat',

// EMAIL
  EMAIL_CONFIG = 'mail-config',

  // Hours for year month (Quotas)
  HOURS_FOR_YEAR_MONTH_LIST = 'hours-for-year-month',
  HOURS_FOR_YEAR_MONTH_CREATE = 'hours-for-year-month',
  HOURS_FOR_YEAR_MONTH_UPDATE = 'hours-for-year-month',
  HOURS_FOR_YEAR_MONTH_DELETE = 'hours-for-year-month',
  HOURS_FOR_YEAR_MONTH_BY_EMPLOYEE = 'hours-for-year-month/employee',
  HOURS_FOR_YEAR_MONTH_BY_EMPLOYEE_YEAR = 'hours-for-year-month/employee',

  // Exigences per days (Planning requirements)
  EXIGENCES_PER_DAYS_CREATE = 'exigencesPerDays/create',
  EXIGENCES_PER_DAYS_FILTER = 'exigencesPerDays/filter',
  EXIGENCES_PER_DAYS_LIST_NO_PAGINATION = 'exigencesPerDays/listNoPagination',
  EXIGENCES_PER_DAYS_ERASE = 'exigencesPerDays/erase/',
}
